interface GetGapSummaryReportDownloadCellValueInput {
    trqkGapSummary: TrqkGapSummary;
    exportingGapAnalysisIdsString: string;
}

export const getGapSummaryReportDownloadCellValue = ({
    trqkGapSummary,
    exportingGapAnalysisIdsString,
}: GetGapSummaryReportDownloadCellValueInput): GapSummaryReportDownloadCellValue => {
    const {
        gap_analysis_id: gapAnalysisId,
        channel_count,
        complete,
    } = trqkGapSummary;

    const channelCount = channel_count ?? 0;

    try {
        const exportingGapAnalysisIds: string[] = JSON.parse(
            exportingGapAnalysisIdsString,
        );

        return {
            complete,
            channelCount,
            gapAnalysisId,
            isExporting: exportingGapAnalysisIds.includes(gapAnalysisId),
        };
    } catch {
        return {
            complete,
            channelCount,
            gapAnalysisId,
            isExporting: false,
        };
    }
};
